<template>
  <section
    class="booking-mobile-time-slots"
    v-if="ui.calendarViewType == 'week'"
  >
    <div class="padding-top-xs-1 padding-bottom-xs-1" v-if="ui.loading.times">
      <img
        class="loading-spinner-nk"
        src="/wp-content/themes/nordiskakliniken/dist/images/loading-spinner.svg"
      />
    </div>

    <div v-if="noAvailableTimesForWeek && 1 == 0"></div>

    <div
      class="book-time-single-date-xs padding-top-xs-1 padding-bottom-xs-0"
      v-for="weekday in dates.active.weekdays"
      :key="'booking-calendar-week-mobile-date-' + weekday.niceDate"
      :class="{
        'bg-gray': dates.current.niceDate == weekday.niceDate,
        'padding-bottom-xs-1': dates.current.niceDate == weekday.niceDate,
      }"
      v-if="!ui.loading.times && weekday.activeTimes.length"
    >
      <span
        class="booking-calendar-week-mobile-date-anchor"
        :id="'booking-calendar-week-mobile-date-anchor-' + weekday.niceDate"
      ></span>
      <div class="book-time-single-date-headline">
        <p
          :class="{
            'text-underline': dates.current.niceDate == weekday.niceDate,
          }"
        >
          <span
            v-if="
              dates.current.niceDate == weekday.niceDate &&
              getRealWeekday != 'Sunday'
            "
            >Idag, </span
          >{{ weekday.longName }} {{ weekday.dayOfMonth }}
          <span class="text-lowercase">{{ weekday.monthLongName }}</span>
        </p>
      </div>
      <div class="book-time-single-date-content padding-bottom-xs-0">
        <a
          href="#"
          class="margin-bottom-xs-1"
          v-for="slot in weekday.activeTimes"
          @click.prevent="
            setSelectedSlot(slot);
            setModalState(4);
          "
          :class="{
            selected:
              selectedSlot &&
              String(selectedSlot.date) === String(slot.date) &&
              String(selectedSlot.time) === String(slot.time) &&
              String(selectedSlot.location_id) === String(slot.location_id) &&
              String(selectedSlot.terapeut_id) === String(slot.terapeut_id),
          }"
          v-if="
            !ui.loading.times &&
            activities.selected &&
            slot.terapeut_id != 8888888
          "
        >
          <div class="book-time-single-slot book-time-single-slot-mobile">
            <p
              class="book-time-single-slot-time book-time-single-slot-time-mobile"
            >
              {{ slot.time }}
            </p>
            <p
              class="book-time-single-slot-practitioner text-small"
              v-html="formatProviderName(slot.terapeut_sign)"
            ></p>
            <p
              class="book-time-single-slot-practitioner book-time-location book-time-location-mobile text-small"
            >
              {{ slot.location_short_name }}
            </p>
          </div>
        </a>
        <p
          class="margin-bottom-xs-0"
          v-if="
            !weekday.activeTimes.length &&
            !ui.loading.times &&
            activities.selected
          "
        >
          <span class="text-gray">Inga tider</span>
        </p>
        <p
          v-if="
            !weekday.activeTimes.length &&
            !ui.loading.times &&
            !activities.selected
          "
          class="margin-top-xs-1 margin-bottom-xs-1"
        >
          Välj behandling för att se tider
        </p>
      </div>
    </div>
    <div
      class="book-time-single-date-xs margin-top-xs-2 padding-top-xs-2 padding-bottom-xs-2 bg-gray select-week-info-box"
      v-if="!ui.loading.times"
    >
      <h3
        class="margin-top-xs-0 padding-top-xs-0 margin-bottom-xs-1 padding-bottom-xs-0"
      >
        Växla vecka i menyn ovan för fler lediga tider.
      </h3>
      <p class="mb-0">
        <a href="#" class="link-arrow-right" @click.prevent="scrollToNav()"
          >Till toppen av sidan</a
        >
      </p>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ProviderAndCalendarNavMobile from './ProviderAndCalendarNavMobile.vue';
import BookingCalendarMonth from './BookingCalendarMonth.vue';

export default {
  components: {
    ProviderAndCalendarNavMobile,
    BookingCalendarMonth,
  },
  computed: {
    ...mapState([
      'activityGroups',
      'activities',
      'providers',
      'selectedSlot',
      'dates',
      'ui',
      'booking',
      'patient',
    ]),
    ...mapGetters([
      'totalAvailableTimes',
      'dateIsInThePast',
      'activityIsCampaign',
      'formatProviderName',
      'selectedSlotFormated',
      'formIsValid',
      'noAvailableTimesForWeek',
    ]),
  },
  methods: {
    ...mapActions([
      'setActivityGroup',
      'setActivity',
      'setupActiveDates',
      'setSelectedSlot',
      'setProvider',
      'getRealWeekday',
      'setModalState',
      'handleSwipe',
      'shouldDeselectTimeslot',
    ]),
    scrollToNav() {
      let modalBody = document.querySelector('.modal-time-slots-body');
      this.$store.state.vueInstance.$SmoothScroll(0, 500, false, modalBody);
    },
  },
};
</script>
